<template>
  <van-swipe class="banner-swipe" autoplay="5000" indicator-color="#E83828">
    <van-swipe-item v-for="(item, i) in banners" :key="i" @click="viewDetails(item.gotourl)">
      <van-image class="banner" lazy-load :src="item.fileurl" />
    </van-swipe-item>
  </van-swipe>
</template>

<script>
import { FRONTEND_HOST } from '@/config/domainnameconstant'
export default {
  name: 'BannerSwipe',
  props: {
    banners: Array
  },
  methods: {
    viewDetails(url) {
      if (!url) {
        return
      }

      if (this.$getUA() === 2) {
        this.hideTabBar()

        if (!url.startsWith(FRONTEND_HOST)) {
          this.showBack()
        }
      }

      window.location.href = url
    },

    /**
     * 隐藏底部栏
     */
    hideTabBar() {
      // this.$callApp('Android', 'HiddenTabBarMethod', '')
      this.$callApp('iOS', 'HiddenTabBarMethod', '')
    },

    /**
     * 显示返回按钮
     */
    showBack() {
      // this.$callApp('Android', 'ShowWebBackButtonMethod', '')
      this.$callApp('iOS', 'ShowWebBackButtonMethod', '')
    }
  }
}
</script>

<style lang="less" scoped>
.banner-swipe {
  padding-top: 84px;
}

.van-swipe-item {
  height: 199px;
}

.banner {
  height: 100%;
  min-width: 100%;
}
</style>
